import SelectSearch from '@/components/react-hook-form-inputs/select-search/select-search-component';
import {
  requiredValidationDropdownMessage,
  requiredValidationMessage,
} from '@/utils/validations';
import PropTypes from 'prop-types';
import { BsX } from 'react-icons/bs';
import { FiPercent } from 'react-icons/fi';
import {
  PrimaryButton,
  PrimaryOutlineButton,
} from '../button/button-component';
import Input from '../react-hook-form-inputs/input/input-component';
import ToggleSwitch from '../react-hook-form-inputs/toggle-switch/toggle-switch-component';
import Styled from './currency-settings-form-style';
/**
 * CurrencySettingsForm component
 * @param {object} props - props
 * @param {Function} props.closeCurrencySettingsModal - closeCurrencySettingsModal
 * @param {Array} props.currencies - currencies
 * @param {boolean} props.isLoading - isLoading
 * @returns {JSX.Element} The rendered CurrencySettingsForm component
 */
const CurrencySettingsForm = ({
  closeCurrencySettingsModal,
  currencies,
  isLoading,
}) => {
  const currencyOptions = currencies?.map((currency) => ({
    value: currency.id,
    label: currency.name,
  }));

  return (
    <>
      <Styled.Main>
        <SelectSearch
          isLoading={isLoading}
          isDisabled={isLoading}
          header="Default Currency"
          name="currency_id"
          placeholder="Select"
          options={currencyOptions}
          required={{
            required: requiredValidationDropdownMessage,
          }}
        />
        <ToggleSwitch
          disabled={isLoading}
          label="Override automatic exchange rate"
          name="override_automatic_exchange_rate"
        />
        <Input
          disabled={isLoading}
          inputStyle={{ paddingRight: 7 }}
          label="Exchange Rate Increase Percentage"
          placeholder="Exchange Rate Increase Percentage"
          name="exchange_rate_increase_percentage"
          type="number"
          iconRight={<FiPercent />}
          registerOptions={{
            required: requiredValidationMessage,
          }}
        />
        {/* disclaimer will not work until we cater for this in BE */}
        <Input
          disabled={isLoading}
          inputStyle={{ minHeight: 250 }}
          placeholder="Description"
          name="disclaimer"
          textArea
          initialValue={`The prices quoted in this document has been calculated using the current monthly average rate of exchange (AROE) based on 18.92 ZAR: 1 USD. | The AROE has been determined by the Supplier's internationally recognised banking institution.\n\nRegardless of validity of the quotation, this AROE will be reviewed monthly, and the eﬀect of this review will be applied accordingly should any fluctuation in excess of 3% occur in either direction.`}
        />
      </Styled.Main>
      <Styled.ButtonContainer>
        <PrimaryOutlineButton
          loading={isLoading}
          buttonWidth="112px"
          margin="0 24px 0 auto"
          type="button"
          icon={<BsX />}
          title="Cancel"
          onClick={() => closeCurrencySettingsModal()}
        />
        <PrimaryButton
          loading={isLoading}
          buttonWidth="108px"
          type="submit"
          title="Update"
        />
      </Styled.ButtonContainer>
    </>
  );
};

CurrencySettingsForm.propTypes = {
  closeCurrencySettingsModal: PropTypes.func.isRequired,
  currencies: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default CurrencySettingsForm;
